<div class="ai-suggestion-bar" role="region" aria-label="AI Code Suggestions">
	<div class="suggestion-input-container">
		<!-- AI Sparkle Indicator -->
		<!-- <div class="ai-indicator">
			<mat-icon class="sparkle-icon">auto_awesome</mat-icon>
		</div> -->

		<input
			type="text"
			class="suggestion-prompt"
			[(ngModel)]="state.prompt"
			(ngModelChange)="onPromptChange()"
			placeholder="e.g., 'add padding: 16px' or 'change background color'"
			i18n-placeholder="AI Suggestion Prompt Placeholder@@aiCodeSuggestionsPromptPlaceholder"
			[disabled]="state.status === 'loading'"
			(keydown.enter)="applySuggestion()"
			aria-label="AI suggestion prompt"
		/>

		<button
			*ngIf="state.status !== 'success' || !state.canUndo"
			class="apply-btn"
			[disabled]="!state.prompt.trim() || state.status === 'loading'"
			(click)="applySuggestion()"
			aria-label="Apply AI suggestion"
		>
			<mat-icon *ngIf="state.status !== 'loading'">auto_fix_high</mat-icon>
			<mat-spinner *ngIf="state.status === 'loading'" diameter="18"></mat-spinner>
			<span *ngIf="state.status !== 'loading'" i18n="Apply Button@@aiCodeSuggestionsApplyButton">Go</span>
		</button>

		<button
			*ngIf="state.status === 'success' && state.canUndo"
			class="undo-btn"
			(click)="undoSuggestion()"
			aria-label="Undo AI suggestion"
		>
			<mat-icon>undo</mat-icon>
			<span i18n="Undo Button@@aiCodeSuggestionsUndoButton">Undo</span>
		</button>
	</div>

	<!-- Enhanced Loading Indicator -->
	<div *ngIf="state.status === 'loading'" class="loading-indicator">
		<div class="loading-bar"></div>
		<span class="loading-text" i18n="Loading Text@@aiCodeSuggestionsLoadingText">AI is analyzing your code...</span>
	</div>

	<div
		*ngIf="state.status === 'error'"
		class="error-message"
		role="alert"
		aria-live="polite"
	>
		{{ state.errorMessage }}
		<button class="retry-btn" (click)="applySuggestion()" i18n="Retry Button@@aiCodeSuggestionsRetryButton">Retry</button>
	</div>

	<div
		*ngIf="state.status === 'success' && state.explanation"
		class="explanation"
		aria-live="polite"
	>
		<strong i18n="Changes Label@@aiCodeSuggestionsChangesLabel">Changes:</strong> {{ state.explanation }}
	</div>
</div>
